"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var rc_menu_1 = require("rc-menu");
var DropdownMenuItem = function (_a) {
    var before = _a.before, after = _a.after, children = _a.children, props = __rest(_a, ["before", "after", "children"]);
    return react_1.jsx(rc_menu_1.MenuItem, __assign({}, props),
        before && react_1.jsx("div", { className: "menu-item-before" }, before),
        children,
        after && react_1.jsx("div", { className: "menu-item-after" }, after));
};
exports.default = DropdownMenuItem;
